import * as _ from 'lodash';
import { PageBase, PageOptionsBase } from '../../Common/PageBase';
import { DatatableApi, Datatable, DatatableOptions } from '../../Widgets/Datatable'
import { MultiSelectApi, MultiSelect } from '../../Widgets/MultiSelect'
import { Utils } from '../../Utils/Utils';
import { StatusMessageHelper } from '../../Utils/StatusMessageHelper';
import { DateUtils } from '../../Utils/DateUtils';
import { StringUtils } from '../../Utils/StringUtils';
import { ArrayUtils } from '../../Utils/ArrayUtils';

var tableDom = "<'row'<'col-sm-6'l><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";
var tableDomAssignedGames = "<'row'<'col-sm-6'l><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";

var OFFERS_COLUMN_INDEX = {
    Checkbox: 0,
    Id: 1,
    Name: 2,
    PlayerRemoteId: 3,
    RemoteId: 4,
    Currency: 5,
    Status: 10,
    Result: 11,
    Source: 12
}

var FILTER_DELIM = '-delim-';
var btnCancelSearchId = 'btnCancelSearch';

export interface DetailPageOptions extends PageOptionsBase {
    dataSwitch: string;
    urlList: string;
    urlDetail: string;
    urlPost: string;
    hideCheckboxes: boolean;
    localizer: {
        StatusEnabled: string;
        StatusDisabled: string;
        DetailsLink: string;
        SetupLink: string;
        ConfirmCancel: string;
        Offers: string;
    }
}

export class DetailPage extends PageBase<DetailPageOptions> {

    protected _tableOptions: DatatableOptions;
    protected _table: Datatable;
    protected _tableId: string;

    protected _form: JQuery;

    constructor(options: DetailPageOptions) {
        super(options);

        this.formSubmit = this.formSubmit.bind(this);
    }

    init(): void {
        this._form = Utils.getJQueryById("form" + this._tableId);
        // == create 'new Datatable' instance
        if (Utils.isNullOrUndefined(this._tableOptions))
            return;
        this._table = new Datatable(this._tableId, this._tableOptions);

        this._form.on('submit', this.formSubmit);

        // cancel search click -> reset filter row values
    }

    public static showForm(field: string, focusField: string) {
        $(".multi-hide").hide();
        $(".multi-show").show();

        $(".multi-show").closest(".form-group").removeClass("gray");

        var label = "#lbl" + field;
        var frm = "#frm" + field;
        $(label).hide();
        $(frm).show();

        $(label).closest(".form-group").addClass("gray");

        if (focusField) {
            $('#' + focusField).focus();
        }
    }

    private formSubmit(e: JQueryEventObject): any {
        e.preventDefault();
        this._table.draw();
        return false;
    }

    public static hideForm(field: string) {
        var label = "#lbl" + field;
        var frm = "#frm" + field;
        $(label).show();
        $(frm).hide();

        $(label).closest(".form-group").removeClass("gray");
    }
    protected showHideSelectAllCheckbox(selectAllButton: string, checkboxesIdentifier: string): void {
        let selectAllCheckbox = Utils.getJQueryById(selectAllButton)[0];
        if (Utils.isNullOrUndefined(selectAllCheckbox))
            return;
        var checkboxes = $(checkboxesIdentifier);
        if (checkboxes.length === 0) {
            (<HTMLInputElement>selectAllCheckbox).hidden = true;
        } else {
            (<HTMLInputElement>selectAllCheckbox).hidden = false;
        }
    }
    protected setSelectAllCheckbox(selectAllButton: string, checkboxesIdentifier: string): void {
        let gamesSelectAll = Utils.getJQueryById(selectAllButton)[0];
        if (Utils.isNullOrUndefined(gamesSelectAll))
            return;
        let allCheckboxesChecked = false;
        var checkboxes = $(checkboxesIdentifier);
        for (var i = 0; i < checkboxes.length; i++) {
            allCheckboxesChecked = (<HTMLInputElement>checkboxes[i]).checked;
            if (!allCheckboxesChecked)
                break;
        }
        (<HTMLInputElement>gamesSelectAll).checked = allCheckboxesChecked;
    }
}

export class AssignedOffers extends DetailPage {

    private _btnCancelSearch: JQuery;

    private _filterSource: JQuery;
    private _filterPlayerName: JQuery;
    private _filterPlayerRemoteId: JQuery;
    private _filterRemoteId: JQuery;
    private _filterCurrency: MultiSelectApi;
    private _filterStatus: MultiSelectApi;
    private _filterResult: MultiSelectApi;
    private _chckAllOffers: JQuery;

    constructor(options: DetailPageOptions) {
        super(options);

        this.cancelSelectedOffers = this.cancelSelectedOffers.bind(this);
        this.cancelSearch = this.cancelSearch.bind(this);
        this.preDrawCallback = this.preDrawCallback.bind(this);
        this.checkBoxAll = this.checkBoxAll.bind(this);
        this.drawCallback = this.drawCallback.bind(this);
        this.setSelectAllOfferCheckbox = this.setSelectAllOfferCheckbox.bind(this);
        var getDetailUrl = (rowData: any): string => (`${options.urlDetail}/${rowData.Id}`);
        window['setSelectAllOfferCheckbox'] = this.setSelectAllOfferCheckbox;

        this._tableId = "tableCampaignAssignedOffers";
            this._tableOptions = {
                url: this._options.urlList,
                dom: tableDom,
                rowId: 'id',
                autoWidth: true,
                ordering: true,
                lengthMenu: [[10, 20, 100, -1], [10, 20, 100, "All"]],
                columns: [
                    {
                        sortable: false,
                        data: 'Id',
                        render: (data: any, type: any, rowData: any) => {
                            return (`<input id='chckbx${rowData.Id}' name='selectedOffer' value='${rowData.Id}' type='checkbox' onClick="setSelectAllOfferCheckbox()" />`);
                        }

                    },
                    {
                        data: 'Id',
                        className: "bold",
                        render: (data: any, type: any, rowData: any) =>
                            (`<a id='lnkOfferId${rowData.Id}' href='${getDetailUrl(rowData)}'>${data}</a>`)
                    },
                    {
                        data: "PlayerName",
                        render: (data: any, type: any, rowData: any) => {
                            return data != undefined ? (`<span id='spnOfferPlayerName${rowData.Id}'>${data}</span>`) : ``;
                        }
                    },
                    {
                        data: "PlayerRemoteId",
                        render: (data: any, type: any, rowData: any) =>
                            (`<span id='spnOfferPlayerId${rowData.Id}'>${data}</span>`)
                    },
                    {
                        data: "RemoteId",
                        render: (data: any, type: any, rowData: any) => {
                            return data != undefined ? (`<span id='spnOfferRemoteId${rowData.Id}'>${data}</span>`) : ``;
                        }
                    },
                    {
                        data: "CurrencyCode",
                        render: (data: any, type: any, rowData: any) =>
                            (`<span id='spnOfferPlayerCurrency${rowData.Id}'>${data}</span>`)
                    },
                    {
                        data: "RoundsAssigned",
                        className: 'dt-right',
                        render: (data: any, type: any, rowData: any) =>
                            (`<span id='spnOfferAwardedSpins${rowData.Id}'>${data}</span>`)
                    },
                    {
                        data: "RoundsPlayed",
                        className: 'dt-right',
                        render: (data: any, type: any, rowData: any) =>
                            (`<span id='spnOfferUsedSpins${rowData.Id}'>${data}</span>`)
                    },
                    {
                        data: "PendingSpins",
                        className: 'dt-right',
                        render: (data: any, type: any, rowData: any) =>
                            (`<span id='spnOfferPendingSpins${rowData.Id}'>${data}</span>`)
                    },
                    {
                        data: "TotalWin",
                        className: 'dt-right',
                        render: (data: any, type: any, rowData: any) =>
                            (`<span id='spnOfferTotalWin${rowData.Id}'>${data}</span>`)
                    },
                    {
                        data: "Status",
                        render: (data: any, type: any, rowData: any) =>
                            (`<span id='spnOfferStatus${rowData.Id}'>${data}</span>`)
                    },
                    {
                        data: "Result",
                        render: (data: any, type: any, rowData: any) =>
                            (`<span id='spnOfferResult${rowData.Id}'>${Utils.isNullOrUndefined(data) ? '' : data}</span>`)
                    },
                    {
                        data: "Source",
                        defaultContent: '',
                        visible: false
                    }
                ],
                order: [[OFFERS_COLUMN_INDEX.Name, "asc"]],
                callbacks: {
                    preDrawCallback: this.preDrawCallback,
                    drawCallback: this.drawCallback
                }
            };
    }

    init(): void {
        const btnCancelOffersMulti = Utils.getJQueryById("btnCancelSelected");
        btnCancelOffersMulti.on("click", this.cancelSelectedOffers);
        this._filterSource = Utils.getJQueryById("filterSource");
        this._btnCancelSearch = Utils.getJQueryById(btnCancelSearchId);
        this._filterPlayerName = Utils.getJQueryById('filterPlayerName');
        this._filterPlayerRemoteId = Utils.getJQueryById('filterPlayerRemoteId');
        this._filterRemoteId = Utils.getJQueryById('filterRemoteId');
        this._filterCurrency = new MultiSelectApi('filterCurrency');
        this._filterStatus = new MultiSelectApi('filterStatus');
        this._filterResult = new MultiSelectApi('filterResult');
        this._btnCancelSearch.on('click', this.cancelSearch);
        this._chckAllOffers = Utils.getJQueryById("offersSelectAll");
        this._chckAllOffers.on("change", this.checkBoxAll);
        super.init();
    }

    private cancelSelectedOffers(e: JQueryEventObject): void {
        e.preventDefault();
        if (!confirm(this._options.localizer.ConfirmCancel)) {
            return;
        }
        var urlPost = this._options.urlPost;
        var table = this._table;
        var overview = Utils.getJQueryById('tableCampaignFinanceOverview').DataTable();
        var ids = $("input[name='selectedOffer']:checked").map(function() {
            return $(this).val();
        });
        var idsToCancel = ids.get();
        if (!idsToCancel || idsToCancel.length === 0) {
            return;
        }
        var statusMessage = Utils.getJQueryById("statusMessageWrapper");
        $.ajax({
            url: urlPost,
            type: "POST",
            dataType: 'html',
            data: { offerIds: idsToCancel },
            success: function(data) {
                table.draw();
                overview.draw();
                statusMessage.html(data);
                StatusMessageHelper.initValidator();
                StatusMessageHelper.initSatusMessage();
            }
        });
        Utils.scrollToTop();
    }

    private preDrawCallback(datatable: DatatableApi): any {
        (<HTMLInputElement>this._chckAllOffers[0]).checked = false;
        var filterPlayerName = this._filterPlayerName.val();
        datatable.columns(OFFERS_COLUMN_INDEX.Name).search(filterPlayerName);

        var filterPlayerRemoteId = this._filterPlayerRemoteId.val();
        datatable.columns(OFFERS_COLUMN_INDEX.PlayerRemoteId).search(filterPlayerRemoteId);

        var filterRemoteId = this._filterRemoteId.val();
        datatable.columns(OFFERS_COLUMN_INDEX.RemoteId).search(filterRemoteId);

        var filterCurrency = this._filterCurrency.isAllSelected() ? '' : this._filterCurrency.getSelectionValues(FILTER_DELIM);
        datatable.columns(OFFERS_COLUMN_INDEX.Currency).search(filterCurrency);

        var filterStatus = this._filterStatus.isAllSelected() ? '' : this._filterStatus.getSelectionValues(FILTER_DELIM);
        datatable.columns(OFFERS_COLUMN_INDEX.Status).search(filterStatus);

        var filterResult = this._filterResult.isAllSelected() ? '' : this._filterResult.getSelectionValues(FILTER_DELIM);
        datatable.columns(OFFERS_COLUMN_INDEX.Result).search(filterResult);

        var filterSource = this._filterSource.val();
        if (filterSource != undefined) {
            datatable.columns(OFFERS_COLUMN_INDEX.Source).search(filterSource);
        }

        return true;
    }

    private drawCallback(datatable: DatatableApi): any {
        this.showHideSelectAllCheckbox("offersSelectAll", "input[name='selectedOffer']");
    }

    private cancelSearch(e: JQueryEventObject): void {
        this._filterPlayerName.val('');
        this._filterPlayerRemoteId.val('');
        this._filterRemoteId.val('');
        this._filterCurrency.selectAll();
        this._filterStatus.selectAll();
        this._filterResult.selectAll();
        this._filterSource.val('Live');
    }

    private checkBoxAll(): void {
        var checkboxes = $("input[name='selectedOffer']");
        for (var i = 0; i < checkboxes.length; i++) {
            (<HTMLInputElement>checkboxes[i]).checked = (<HTMLInputElement>this._chckAllOffers[0]).checked;
        }
    }

    private setSelectAllOfferCheckbox(): void {
        this.setSelectAllCheckbox("offersSelectAll", "input[name='selectedOffer']");
    }
}

export class AssignedGames extends DetailPage {

    private _chckAllGames: JQuery;

    constructor(options: DetailPageOptions) {
        super(options);

        var getSetupUrl = (rowData: any): string => (`${options.urlDetail}/${rowData.BetSettingId}`);
        this.removeSelectedGames = this.removeSelectedGames.bind(this);
        this.checkBoxAll = this.checkBoxAll.bind(this);
        this.preDrawCallback = this.preDrawCallback.bind(this);
        this.drawCallback = this.drawCallback.bind(this);
        this.setSelectAllGamesCheckbox = this.setSelectAllGamesCheckbox.bind(this);

        window['setSelectAllGamesCheckbox'] = this.setSelectAllGamesCheckbox;

        this._tableId = "tableCampaignAssignedGames";
            this._tableOptions = {
                url: this._options.urlList,
                dom: tableDomAssignedGames,
                rowId: 'betSettingId',
                autoWidth: true,
                ordering: true,
                lengthMenu: [[10, 20, 100, -1], [10, 20, 100, "All"]],
                columns: [
                    {
                        data: 'BetSettingId',
                        width: '5%',
                        sortable: false,
                        visible: !this._options.hideCheckboxes,
                        render: (data: any, type: any, rowData: any) =>
                            (`<input id='chckbx${rowData.BetSettingId}' name='selectedGame' value='${rowData.BetSettingId}' type='checkbox' onClick="setSelectAllGamesCheckbox()" />`)
                    },
                    {
                        data: "GameName",
                        width: '15%',
                        render: (data: any, type: any, rowData: any) =>
                            (`<a id='lnkGameName${rowData.BetSettingId}' href='${getSetupUrl(rowData)}'>${data}</a>`)
                    },
                    {
                        data: "CurrencyCode",
                        width: '5%',
                        render: (data: any, type: any, rowData: any) =>
                            (`<span id='spnGameCurrency${rowData.BetSettingId}'>${data}</span>`)
                    },
                    {
                        data: "GambleEnabled",
                        width: '10%',
                        render: (data: any, type: any, rowData: any) =>
                            (`<span id='spnGameGambleEnabled${rowData.BetSettingId}'>${data}</span>`)
                    },
                    {
                        data: "BetType",
                        width: '10%',
                        render: (data: any, type: any, rowData: any) =>
                            (`<span id='spnGamebetType${rowData.BetSettingId}'>${data}</span>`)
                    },
                    {
                        data: "PaylineCount",
                        width: '10%',
                        render: (data: any, type: any, rowData: any) => {
                            var val = data == null ? 'N/A' : data;
                            return (`<span id='spnGamePaylineCount${rowData.BetSettingId}'>${val}</span>`);
                        }
                    },
                    {
                        data: "CoinCount",
                        width: '10%',
                        render: (data: any, type: any, rowData: any) =>
                            (`<span id='spnGameCoinCount${rowData.BetSettingId}'>${data}</span>`)
                    },
                    {
                        data: "CoinSize",
                        width: '10%',
                        render: (data: any, type: any, rowData: any) =>
                            (`<span id='spnGameCoinSize${rowData.BetSettingId}'>${data}</span>`)
                    },
                    {
                        data: "ValuePerSpin",
                        width: '10%',
                        render: (data: any, type: any, rowData: any) =>
                            (`<span id='spnGameValuePerSpin${rowData.BetSettingId}'>${data}</span>`)
                    }
                ],
                order: [[1, "asc"]],
                callbacks: {
                    preDrawCallback: this.preDrawCallback,
                    drawCallback: this.drawCallback
                }
            };
    }
    init():void {
        const btnRemoveMulti = Utils.getJQueryById("btnRemoveSelected");
        btnRemoveMulti.on("click", this.removeSelectedGames);
        this._chckAllGames = Utils.getJQueryById("gamesSelectAll");
        this._chckAllGames.on("change", this.checkBoxAll);
        super.init();
    }

    private checkBoxAll(): void {
        var checkboxes = $("input[name='selectedGame']");
        for (var i = 0; i < checkboxes.length; i++) {
            (<HTMLInputElement>checkboxes[i]).checked = (<HTMLInputElement>this._chckAllGames[0]).checked;
        }
    }

    private removeSelectedGames(e: JQueryEventObject): void {
        e.preventDefault();
        var urlPost = this._options.urlPost;
        var table = this._table;
        var overview = Utils.getJQueryById('tableCampaignFinanceOverview').DataTable();
        var ids = $("input[name='selectedGame']:checked").map(function() {
            return $(this).val();
        });
        var statusMessage = Utils.getJQueryById("statusMessageWrapper");
        $.ajax({
            url: urlPost,
            type: "POST",
            dataType: 'html',
            data: { betSettingIds: ids.get() },
            success: function(data) {
                statusMessage.html(data);
                StatusMessageHelper.initValidator();
                StatusMessageHelper.initSatusMessage();
                table.draw();
                overview.draw();
            }
        });
        Utils.scrollToTop();
    }

    private preDrawCallback(datatable: DatatableApi): any {
        (<HTMLInputElement>this._chckAllGames[0]).checked = false;
        return true;
    }

    private drawCallback(datatable: DatatableApi): any {
        this.showHideSelectAllCheckbox("gamesSelectAll", "input[name='selectedGame']");
    }

    private setSelectAllGamesCheckbox(): void {
        this.setSelectAllCheckbox("gamesSelectAll", "input[name='selectedGame']");
    }
}

export class CampaignStatistics extends DetailPage {
    constructor(options: DetailPageOptions) {
        super(options);

        this._tableId = "tableCampaignStatistics";
        this._tableOptions = {
            url: this._options.urlList,
            dom: tableDom,
            rowId: 'CurrencyCode',
            autoWidth: true,
            ordering: false,
            columns: [
                {
                    data: "CurrencyCode",
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnCurrency${rowData.CurrencyCode}'>${data}</span>`)
                },
                {
                    data: "RoundsAssigned",
                    className: 'dt-right',
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnAwardedSpins${rowData.CurrencyCode}'>${data}</span>`)
                },
                {
                    data: "PendingSpins",
                    className: 'dt-right',
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnPendingSpins${rowData.CurrencyCode}'>${data}</span>`)
                },
                {
                    data: "UsedSpins",
                    className: 'dt-right',
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnUsedSpins${rowData.CurrencyCode}'>${data}</span>`)
                },
                {
                    data: "AvgSpinValue",
                    className: 'dt-right',
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnAvgSpinValue${rowData.CurrencyCode}'>${data}</span>`)
                },
                {
                    data: "TotalWin",
                    className: 'dt-right',
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnTotalWin${rowData.CurrencyCode}'>${data}</span>`)
                }
            ]
        };
    }
}


export class OffersOverview extends DetailPage {
    constructor(options: DetailPageOptions) {
        super(options);

        this._tableId = "tableOffersOverview";
        this._tableOptions = {
            url: this._options.urlList,
            dom: tableDom,
            rowId: 'CampaignId',
            paging: false,
            autoWidth: true,
            ordering: false,
            columns: [
                {
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnOffers'>${this._options.localizer.Offers}</span>`)
                },
                {
                    data: "TotalOffers",
                    className: 'dt-right',
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnTotalOffers'>${data}</span>`)
                },
                {
                    data: "Remaining",
                    className: 'dt-right',
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnRemainingOffers'>${data}</span>`)
                },
                {
                    data: "Completed",
                    className: 'dt-right',
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnCompletedOffers'>${data}</span>`)
                },
                {
                    data: "Accepted",
                    className: 'dt-right',
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnAcceptedOffers'>${data}</span>`)
                },
                {
                    data: "Declined",
                    className: 'dt-right',
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnDeclinedOffers'>${data}</span>`)
                },
                {
                    data: "Canceled",
                    className: 'dt-right',
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnCanceledOffers'>${data}</span>`)
                }
            ]
        };
    }
}


/** WEBPACK FOOTER **
 ** ./Typescript/Pages/FreeRoundCampaigns/DetailPage.ts
 **/